export const addTextMenu = `
                                      <button class="fonts-button">
                                        Arial
                                      </button>

                                      <input class="sizeInput" type="number" value="14" min="1" max="70" />

                                      <input class="text-color-input" type="color" value="black" />

                                      <button class="bold">
                                        B
                                      </button>

                                      <button>
                                        <img class="trash-img" src=${require('../images/trash-icon.PNG')} alt="delete" />
                                      </button>                                

                                      <div class="fonts-container">

                                          <button >
                                              <p class="arial">Arial</p>
                                          </button>

                                          <button>
                                              <p class="lobster">Lobster</p>
                                          </button>

                                          <button>
                                              <p class="calibri">Calibri</p>
                                          </button>
                                          
                                          <button>
                                              <p class="times-new-roman">Times New Roman</p>
                                          </button>

                                          <button>
                                              <p class="gothic">Gothic</p>
                                          </button>
                                          
                                          <button>
                                              <p class="edu-vic-wa">Edu-Vic-Wa</p>
                                          </button>

                                          <button>
                                              <p class="cursive">Cursive</p>
                                          </button>

                                          <button>
                                              <p class="anton">Anton</p>
                                          </button>

                                      </div>
                                    `;